/**
 * @fileoverview
 *
 * Functions to initiate and control `_fwn.player`
 * Web SDK attribute which provides programmatic access
 * to a current fullscreen/minimized player.
 */

import { getFWN } from '@core/fwn'

import { PlayerNoop } from './PlayerNoop'
import type { IPlayer } from './types'

const noopPlayer = new PlayerNoop()
let activePlayerCache: IPlayer | null = null

/**
 * Used to provide `_fwn.player` attribute getter
 * and with access to module level cache.
 */
export function fwnPlayerGetter(): IPlayer {
  return activePlayerCache ?? (activePlayerCache = noopPlayer)
}

/**
 * Used to provide `_fwn.player` attribute setter
 * interface to module level cache.
 */
export function fwnPlayerSetter(player: IPlayer): void {
  activePlayerCache = player
}

/**
 * Used by a component to set an active player via one
 * of the keys. Keys will be used to search for a player
 * in all players cache and assign a reference to it.
 */
export function setActiveFWNPlayer(widgetId: string) {
  const fwn = getFWN()
  if (fwn) {
    fwn.player = noopPlayer
    if (fwn.players[widgetId]) {
      fwn.player = fwn.players[widgetId]
    }
  }
}

/**
 * Used by a component to unset active player during cleanup.
 */
export function unsetActiveFWNPlayer() {
  const fwn = getFWN()

  if (fwn) {
    fwn.player = noopPlayer
  }
}
